import 'typeface-nunito';
import 'typeface-noto-serif';
import 'typeface-inconsolata';

import './src/tailwind.generated.css';
